import { ProductPrice } from '@magentoTypes'

export const getMinimumPrice = (price: ProductPrice) => {
  return price?.final_price?.value !== price?.regular_price?.value
    ? price.final_price
    : price.regular_price
}
